var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.602 8.893-16.14 16.14v14.5h3.54v-9.55c0-2.72 2.23-4.86 4.86-4.86 2.63 0 4.86 2.22 4.86 4.86v9.55h19.02v-14.5c-6.26-6.25-9.8-9.8-16.14-16.14Zm12.68 27.34h-12.68v-11.11h12.68v11.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.283 26.433h-4.36v8.49h4.36v-8.49ZM26.602 26.433v8.49h4.37v-8.49h-4.37ZM38.792 17.953 21.582.743c-.99-.99-2.72-.99-3.71 0L.742 17.953c-.99.99-.99 2.72 0 3.71.71.71 1.79.9 2.72.59.37-.12.71-.31.99-.59l15.32-15.32 15.31 15.32c.2.19.42.34.66.45.98.48 2.25.34 3.05-.46.99-1.07.99-2.72 0-3.71v.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default ForwardRef;